import { jsx as _jsx } from "@emotion/react/jsx-runtime";
import { Skeleton } from '@/components/ui/FeedBack/Skeleton';
import { ContentWithAvatar } from '@/components/ui/Image/ContentWithAvatar';
const sizes = {
    md: 'w-[40px] h-[40px]',
    sm: 'w-[30px] h-[30px]',
};
export const UserBoxSkeleton = (props) => {
    const { className = '', size = 'md' } = props;
    return (_jsx(ContentWithAvatar, Object.assign({ avatarComponent: _jsx(Skeleton, { className: sizes[size], roundedCorner: 'full' }), className: className }, { children: _jsx(Skeleton, { className: 'w-[160px] h-[30px]' }) })));
};
